module.exports = __webpack_public_path__ + "img/information-circle-outline.3234c7c7.svg";